import { ActionInfo } from "./ActionInfoTypes";

// -----
// *** COLLECT ACTIONS ***
// -----

export const Collect_3005: ActionInfo = {
  id: "collect_3005",
  type: "Collect",
  title: "Brick 1x1 (+1)",
  details: "Click to collect Brick 1x1",
  cost: [],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3005",
      baseChangeValue: 1,
    },
  ],
  actionVisibility: [
    {
      actionId: "create_3004",
    },
  ],
  isBrickpack: false,
};
